/**
 * Gde je API — na jednom mestu, jer su svi ekrani ovde ranije imali svoju
 * kopiju. Kopija je i bila kvar: adresa se popravi u jednoj, a vozacev telefon
 * i dalje zove staru.
 *
 * Prazno znaci: ista adresa sa koje je stranica ucitana. Pozive na /api
 * prosledjuje razvojni server backendu (package.json, "proxy"), a u radu to radi
 * hosting. Time pretrazivac prica sa jednim domacinom: otpada kolacic koji se ne
 * salje na drugi sajt (SameSite=Lax), otpada CORS, i ne treba otvarati jos jedan
 * port na zastitnom zidu — sto je na probi sa telefona i bilo ono sto je stajalo
 * na putu.
 *
 * REACT_APP_API_URL pretice, kad API stvarno stoji drugde.
 */
export const API_BASE = process.env.REACT_APP_API_URL || '';
